import { Button } from '@dynamika-shared/ui/Button/Button';
import { twMerge } from '@utils/twMerge';
import { useAuth0 } from '@auth0/auth0-react';
import { SmallLogo } from '@dynamika-shared/ui/icons';
import { useAuthSlice } from '@restore/auth/auth.slice';

import { SUPPORT_EMAIL, SUPPORT_TEXT, textMap } from './constants';

export const ErrorPage = ({ error = '' }: { error: string }) => {
  const { logout } = useAuth0();
  const clearUser = useAuthSlice((state, actions) => actions.clearUser);

  const textData = textMap[error] || textMap.unknown;

  const handleLogout = () => {
    clearUser();

    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <div className='flex flex-col justify-between h-full w-full items-center'>
      <SmallLogo className='m-6 min-h-[92px] min-w-[92px]' />
      <div className='flex h-full flex-col items-center justify-center -mt-10 w-full'>
        <h2
          className={
            'text-left text-[3.6rem] font-semibold leading-[4rem] tracking-normal uppercase'
          }
        >
          {textData.title}
        </h2>
        <p className='mb-6 mt-2.5 text-1624 w-[50%] text-center whitespace-pre-line'>
          {textData.text}
        </p>
        <Button
          type='primary'
          className={twMerge(
            'border-vermillion bg-vividTangelo transition-colors hover:bg-blue-500 min-w-[14.4rem] rounded-[1.6rem]'
          )}
          onClick={handleLogout}
        >
          <span className='text-1624 font-semibold text-white'>
            Go to Login
          </span>
        </Button>
      </div>
      <div className='border-[1px] border-brightGray py-[16px] w-full flex justify-center gap-1 text-spanishGray text-1420'>
        <span>{SUPPORT_TEXT}</span>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          target='_blank'
          className='text-vividTangelo'
        >
          {SUPPORT_EMAIL}
        </a>
      </div>
    </div>
  );
};
